import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import esCommon from './locales/es/common.json'
import esNavbar from './locales/es/navbar.json'
import esFooter from './locales/es/footer.json'
import esHero from './locales/es/hero.json'
import esLanding from './locales/es/landing.json'
import esAboutUs from './locales/es/aboutUs.json'
import esLevels from './locales/es/levels.json'
import esContact from './locales/es/contact.json'
import esSwrya from './locales/es/swrya.json'
import esSolutionsRfid from './locales/es/solutionsRfid.json'
import esPrivacy from './locales/es/privacy.json'
import esVisiontecLanding from './locales/es/visiontecLanding.json'
import esSoporte from './locales/es/soporte.json'
import esCatalogo from './locales/es/catalogo.json'

import enCommon from './locales/en/common.json'
import enNavbar from './locales/en/navbar.json'
import enFooter from './locales/en/footer.json'
import enHero from './locales/en/hero.json'
import enLanding from './locales/en/landing.json'
import enAboutUs from './locales/en/aboutUs.json'
import enLevels from './locales/en/levels.json'
import enContact from './locales/en/contact.json'
import enSwrya from './locales/en/swrya.json'
import enSolutionsRfid from './locales/en/solutionsRfid.json'
import enPrivacy from './locales/en/privacy.json'
import enVisiontecLanding from './locales/en/visiontecLanding.json'
import enSoporte from './locales/en/soporte.json'
import enCatalogo from './locales/en/catalogo.json'

const STORAGE_KEY = 'vt-lang'

const getStoredLanguage = () => {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (error) {
    return null
  }
}

i18n
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage() || 'es',
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    defaultNS: 'navbar',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      es: {
        common: esCommon,
        navbar: esNavbar,
        footer: esFooter,
        hero: esHero,
        landing: esLanding,
        aboutUs: esAboutUs,
        levels: esLevels,
        contact: esContact,
        swrya: esSwrya,
        solutionsRfid: esSolutionsRfid,
        privacy: esPrivacy,
        visiontecLanding: esVisiontecLanding,
        soporte: esSoporte,
        catalogo: esCatalogo,
      },
      en: {
        common: enCommon,
        navbar: enNavbar,
        footer: enFooter,
        hero: enHero,
        landing: enLanding,
        aboutUs: enAboutUs,
        levels: enLevels,
        contact: enContact,
        swrya: enSwrya,
        solutionsRfid: enSolutionsRfid,
        privacy: enPrivacy,
        visiontecLanding: enVisiontecLanding,
        soporte: enSoporte,
        catalogo: enCatalogo,
      },
    },
  })

export default i18n
